import { z } from 'zod';

import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const KitPriceAdjustmentTypeSchema = z.enum(['NONE', 'PERCENT', 'VALUE']);

export const KitCompositionModeSchema = z.enum(['FIXED', 'SLOT']);

export const KitComponentTypeSchema = z.enum(['PRODUCT', 'SERVICE']);

export const KitComponentInputSchema = z.object({
  itemType: KitComponentTypeSchema,
  itemId: z.uuid(),
  quantity: z.number().int().positive(),
});

/** BR-PRD-48 — slot por categoria (taxonomia do item): quantidade + peso de rateio. */
export const KitSlotInputSchema = z.object({
  categoryId: z.uuid(),
  quantity: z.number().int().positive(),
  allocationWeight: z.number().int().positive(),
});

export const KitSlotResponseSchema = z.object({
  categoryId: z.uuid(),
  categorySlug: z.string().nullable(),
  categoryName: z.string().nullable(),
  quantity: z.number().int(),
  allocationWeight: z.number().int(),
  position: z.number().int().nonnegative(),
});

export const KitComponentResponseSchema = z.object({
  itemType: KitComponentTypeSchema,
  itemId: z.uuid(),
  name: z.string(),
  code: z.string().nullable(),
  quantity: z.number().int(),
  unitPriceCents: z.string().regex(/^\d+$/).nullable(),
  missingPrice: z.boolean(),
  lineTotalCents: z.string().regex(/^\d+$/).nullable(),
});

export const KitPriceBreakdownResponseSchema = z.object({
  subtotalCents: z.string().regex(/^\d+$/),
  adjustmentCents: z.string().regex(/^-?\d+$/),
  totalCents: z.string().regex(/^\d+$/),
  missingPriceCount: z.number().int().nonnegative(),
});

export const KitResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  sku: z.string().nullable(),
  categoryId: z.uuid().nullable(),
  categorySlug: z.string().nullable(),
  internalNotes: z.string().nullable(),
  status: CatalogItemStatusSchema,
  version: z.number().int(),
  compositionMode: KitCompositionModeSchema,
  priceAdjustmentType: KitPriceAdjustmentTypeSchema,
  priceAdjustmentValue: z.string().regex(/^-?\d+$/),
  components: z.array(KitComponentResponseSchema),
  slots: z.array(KitSlotResponseSchema),
  // BR-PRD-49 — kit SLOT não expõe preço derivado no hub; resolução acontece na OS
  priceResolvedOnOs: z.boolean(),
  pricing: KitPriceBreakdownResponseSchema.nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type KitPriceAdjustmentTypeContract = z.infer<typeof KitPriceAdjustmentTypeSchema>;
export type KitCompositionModeContract = z.infer<typeof KitCompositionModeSchema>;
export type KitComponentTypeContract = z.infer<typeof KitComponentTypeSchema>;
export type KitComponentInput = z.infer<typeof KitComponentInputSchema>;
export type KitComponentResponse = z.infer<typeof KitComponentResponseSchema>;
export type KitSlotInput = z.infer<typeof KitSlotInputSchema>;
export type KitSlotResponse = z.infer<typeof KitSlotResponseSchema>;
export type KitPriceBreakdownResponse = z.infer<typeof KitPriceBreakdownResponseSchema>;
export type KitResponse = z.infer<typeof KitResponseSchema>;
